export function getAll() {
  return [
    {
      value: -1,
      name: "All",
      text: "全部",
    },
    {
      value: 0,
      name: "Request",
      text: "請求",
    },
    {
      value: 1,
      name: "Response",
      text: "回應",
    },
  ];
}

export function getByValue(value) {
  return getAll().find((item) => item.value == value);
}
